import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Button, Row } from "react-bootstrap";
import { FiltersButton, TableHeader, WithRoleAccess } from "@services/ui-components";
import VioletBadge from "@services/ui-components/src/VioletBadge/VioletBadge";
import { ProductsFilterI } from "./types";
import WarehousesGoodsFilter from "./components/WarehousesGoodsFilter";
import WarehousesGoodsTable from "./components/WarehousesGoodsTable";
import { useNavigate, useParams } from "react-router-dom";
import { CompanyAccess } from "@me-team/host/main/graphql/types";
import {
    getCurrentStepFromLocalStorage,
    getWarehouseTutorialType,
    isWarehouseTutorialActive,
    moveStepInLocalStorage,
    StepDirection,
} from "../Joyride/WarehouseTutorial/joyrideStepHelpers";
import WarehouseJoyrideWrapper from "../Joyride/WarehouseTutorial/WarehouseJoyrideWrapper";

const WarehousesGoods: React.FC = () => {
    const { t } = useTranslation();
    const { storageId, branchId } = useParams();
    const navigate = useNavigate();
    const tutorialActive = isWarehouseTutorialActive();
    const tutorialType = getWarehouseTutorialType();
    const startStep = getCurrentStepFromLocalStorage();

    const [address, setAddress] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const initialValueFilter: ProductsFilterI = {
        nameSkuBarcode: null,
        categoryId: null,
        brand: null,
        stockStatus: null,
    };
    const [filters, setFilters] = useState<ProductsFilterI>(initialValueFilter);
    const toggleFilters = () => setShowFilters(!showFilters);

    return (
        <>
            <VioletBadge text={t("Manage warehouse products: arrival, write-off, transfer, deletion.")} />
            <TableHeader
                title={address}
                paths={[
                    { path: location?.pathname, label: t("Warehouse accounting") },
                    { path: `/warehouses/branch/${branchId}`, label: t("Warehouses") },
                    { path: location?.pathname, label: address },
                ]}
                colSize={7}
                btnColSize={5}
                buttons={
                    <Row className="gx-3 justify-content-end align-items-center mt-4 mt-lg-0">
                        <WithRoleAccess
                            anyPermissions={[
                                CompanyAccess.WarehouseProductCreateAndAdd,
                                CompanyAccess.WarehouseProductAdd,
                            ]}
                        >
                            <Col xs={12} sm={6} lg={8} xl={7}>
                                <Button
                                    variant="primary"
                                    className="w-100 text-white mb-3 mb-lg-0 mx-0 position-relative text-truncate"
                                    onClick={() => {
                                        tutorialActive && moveStepInLocalStorage(StepDirection.NEXT);
                                        navigate(`/warehouses/add-product/${storageId}/branch/${branchId}`);
                                    }}
                                    data-tour="add-products-to-warehouse-btn"
                                >
                                    <i className="bi bi-plus-lg fw-bold me-1 w-100 h-100"></i>
                                    {t("Add products to the warehouse")}
                                </Button>
                            </Col>
                        </WithRoleAccess>
                        <Col xs={12} sm={6} lg={4} xl={3}>
                            <FiltersButton
                                filter={filters}
                                showFilters={showFilters}
                                onClick={toggleFilters}
                                classes="mb-3 mb-lg-0"
                            />
                        </Col>
                    </Row>
                }
                showFilters={showFilters}
            >
                <WarehousesGoodsFilter setFilters={setFilters} setFiltersApplied={setFiltersApplied} />
            </TableHeader>
            <WarehousesGoodsTable filters={filters} setAddress={setAddress} filtersApplied={filtersApplied} />
            {tutorialActive && tutorialType && (
                <WarehouseJoyrideWrapper tutorialType={tutorialType} startStep={startStep} />
            )}
        </>
    );
};

export default WarehousesGoods;
